import type { Producto, Proveedor } from '../../domain/entidades'

/** Implementamos un repositorio local con el mismo contrato del adaptador Supabase. */

const CLAVE_PRODUCTOS = 'feria-china-2026:demo-productos'
const CLAVE_PROVEEDORES = 'feria-china-2026:demo-proveedores'

const SEMILLA_PRODUCTOS: Producto[] = [
  {
    id: 'PROV-A-001-P02',
    proveedorCodigo: 'PROV-A-001',
    mueble: 'Butaca Vera',
    categoria: 'Social · Salas · Butaca',
    fob: 42,
    rango: 'Bajo',
    precioVentaCol: 748000,
    precioVentaPan: 210,
    nombreComercial: '',
    notas: '',
    atributosEspeciales: [],
    colorEstructura: 'Nogal, con la pata natural',
    telas: [
      {
        id: 'T01',
        productoId: 'PROV-A-001-P02',
        muestrario: 'WY86-15',
        colores: 'Verde, Azul, Beige',
        tipo: 'Chenille',
        colorFrente: '#748C69',
        colorReverso: '#E0E1DD',
      },
    ],
  },
]

const SEMILLA_PROVEEDORES: Proveedor[] = [{ codigo: 'PROV-A-001', nombre: 'Dongguan Softline Co.' }]

type Listener = () => void
const listeners = new Set<Listener>()

function leerProductos(): Producto[] {
  try {
    const crudo = localStorage.getItem(CLAVE_PRODUCTOS)
    return crudo ? (JSON.parse(crudo) as Producto[]) : SEMILLA_PRODUCTOS
  } catch {
    return SEMILLA_PRODUCTOS
  }
}

function leerProveedores(): Proveedor[] {
  try {
    const crudo = localStorage.getItem(CLAVE_PROVEEDORES)
    return crudo ? (JSON.parse(crudo) as Proveedor[]) : SEMILLA_PROVEEDORES
  } catch {
    return SEMILLA_PROVEEDORES
  }
}

function escribirProductos(productos: Producto[]) {
  localStorage.setItem(CLAVE_PRODUCTOS, JSON.stringify(productos))
  listeners.forEach((fn) => fn())
}

function escribirProveedores(proveedores: Proveedor[]) {
  localStorage.setItem(CLAVE_PROVEEDORES, JSON.stringify(proveedores))
  listeners.forEach((fn) => fn())
}

export function demoListarProductos(): Producto[] {
  return leerProductos()
}

export function demoListarProveedores(): Proveedor[] {
  const existentes = leerProveedores()
  const codigos = new Set(existentes.map((p) => p.codigo))
  // Derivamos proveedores faltantes desde productos guardados.
  const derivados = leerProductos()
    .filter((p) => !codigos.has(p.proveedorCodigo))
    .map((p) => ({ codigo: p.proveedorCodigo, nombre: p.proveedorCodigo }))
  return [...existentes, ...derivados]
}

export function demoUpsertProveedor(proveedor: Proveedor) {
  const proveedores = leerProveedores()
  const idx = proveedores.findIndex((p) => p.codigo === proveedor.codigo)
  if (idx >= 0) proveedores[idx] = { ...proveedores[idx], ...proveedor }
  else proveedores.push(proveedor)
  escribirProveedores(proveedores)
}

export function demoUpsertProducto(producto: Producto) {
  const productos = leerProductos()
  const idx = productos.findIndex((p) => p.id === producto.id)
  if (idx >= 0) productos[idx] = { ...productos[idx], ...producto }
  else productos.push(producto)
  escribirProductos(productos)
}

export function demoCompletarFicha(
  productoId: string,
  cambios: {
    nombreComercial?: string
    precioVentaCol?: number
    precioVentaPan?: number
    notas?: string
    categoria?: string
    linea?: string
    sublinea?: string
    unidadesPorContenedor?: number
  },
) {
  const productos = leerProductos()
  const idx = productos.findIndex((p) => p.id === productoId)
  if (idx === -1) return
  productos[idx] = { ...productos[idx], ...cambios }
  escribirProductos(productos)
}

export function demoActualizarNombreProveedor(codigo: string, nombre: string) {
  const proveedores = leerProveedores()
  const idx = proveedores.findIndex((p) => p.codigo === codigo)
  if (idx === -1) return
  proveedores[idx] = { ...proveedores[idx], nombre }
  escribirProveedores(proveedores)
}

export function demoSuscribir(alCambiar: Listener): () => void {
  listeners.add(alCambiar)
  return () => listeners.delete(alCambiar)
}
